import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../../../api/client';
import { ROUTES } from '../../../api/routes';

// ═══ CONFIGURAÇÃO ═══

export interface ConfigMunicipal {
  id: string;
  nome: string;
  nomeOficial?: string;
  slogan?: string;
  nomePrefeito?: string;
  cargoPrefeito?: string;
  nomeVicePrefeito?: string;
  nomeSecretario?: string;
  logoUrl?: string;
  fotoPrefeito?: string;
  corPrimaria?: string;
  corSecundaria?: string;
  siteOficial?: string;
  telefone?: string;
  cnpj?: string;
  emailInstitucional?: string;
  endereco?: string;
  bairro?: string;
  cep?: string;
  cidade?: string;
  uf?: string;
}

export function useMunicipalConfig() {
  const qc = useQueryClient();

  const query = useQuery<ConfigMunicipal>({
    queryKey: ['municipal-config'],
    queryFn: () => api.get(ROUTES.municipal.configuracao).then(r => r.data),
  });

  const update = useMutation({
    mutationFn: (data: Partial<ConfigMunicipal>) => api.put(ROUTES.municipal.configuracao, data).then(r => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['municipal-config'] }),
  });

  return { config: query.data, isLoading: query.isLoading, update };
}

// ═══ MÍDIAS ═══

export interface MidiaMunicipal {
  id: string;
  titulo: string;
  descricao?: string;
  categoria: string;
  arquivoUrl: string;
  tipoArquivo: string;
  criadoEm: string;
}

export function useMunicipalMidias() {
  const qc = useQueryClient();

  const query = useQuery<MidiaMunicipal[]>({
    queryKey: ['municipal-midias'],
    queryFn: () => api.get(ROUTES.municipal.midias).then(r => r.data),
  });

  const create = useMutation({
    mutationFn: (data: { titulo: string; descricao?: string; categoria: string; arquivoUrl: string; tipoArquivo?: string }) =>
      api.post(ROUTES.municipal.midias, data).then(r => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['municipal-midias'] }),
  });

  const remove = useMutation({
    mutationFn: (id: string) => api.delete(ROUTES.municipal.midiaById(id)).then(r => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['municipal-midias'] }),
  });

  return { midias: query.data || [], isLoading: query.isLoading, create, remove };
}
